import { ReactNode } from 'react';
 
type FormFieldProps = {
  label?: string;
  error?: string;
  children: ReactNode;
  className?: string;
};
 
export const FormField = ({ label, error, children, className }: FormFieldProps) => {
  return (
	<div className={`form-field ${className || ''}`}>
	  {label && <label className="form-label">{label}</label>}
	  {children}
	  {error && <span className="form-error">{error}</span>}
	</div>
  );
};